module.exports = __webpack_public_path__ + "img/svg-meter-gauge-needle.accf10e3.svg";